module.exports = __webpack_public_path__ + "img/text_blind_box.f19b0734.svg";